<template>
<div class="signup-layout">
  <div class="form-container">
    <!-- Logo section -->
    <div class="logo-section">
      <img
        class="header-logo"
        src="@/assets/img/svg/logo-aliaddo.svg"
        alt="Aliaddo"
        height="45"
      />
    </div>

    <el-row :gutter="24" type="flex">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <!-- Progress bar -->
        <div class="progress-section">
          <div class="progress-header">
            <span class="progress-title">Progreso de registro</span>
            <span class="progress-count">{{ filledFields }}/6 campos</span>
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar">
              <div
                class="progress-fill"
                :style="{ width: progressPercentage + '%' }"
              ></div>
            </div>
          </div>
        </div>

        <!-- Skeleton Loader -->
        <div v-if="isLoading" class="skeleton-form">
          <div class="skeleton-field">
            <el-skeleton-item variant="text" style="width: 30%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 40px;" />
          </div>
          <div class="skeleton-field">
            <el-skeleton-item variant="text" style="width: 40%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 40px;" />
          </div>
          <div class="skeleton-field">
            <el-skeleton-item variant="text" style="width: 35%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 40px;" />
          </div>
          <div class="skeleton-field">
            <el-skeleton-item variant="text" style="width: 45%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 40px;" />
          </div>
          <div class="skeleton-field">
            <el-skeleton-item variant="text" style="width: 38%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 40px;" />
          </div>
          <div class="skeleton-field">
            <el-skeleton-item variant="text" style="width: 42%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 40px;" />
            <el-skeleton-item variant="text" style="width: 60%; margin-top: 8px;" />
          </div>
          <div class="skeleton-badges">
            <el-skeleton-item variant="rect" style="height: 30px; width: 100%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 30px; width: 100%; margin-bottom: 8px;" />
            <el-skeleton-item variant="rect" style="height: 30px; width: 100%;" />
          </div>
        </div>

        <!-- Formulario -->
        <el-form v-else ref="formUser" :model="form.model" :rules="form.rules" label-position="top">
          <el-form-item prop="email">
            <div class="field-label">
              <i class="el-icon-message"></i>
              <span>E-Email</span>
              <span class="required">*</span>
            </div>
            <el-input
              v-model.trim="form.model.email"
              :maxlength="128"
              placeholder="ceo@tuempresa.com"
              size="large"
              @change="onChangeEmail"
              @input="updateProgress"
            />
            </el-form-item>

          <el-form-item prop="fullName">
            <div class="field-label">
              <i class="el-icon-user"></i>
              <span>Tus nombres y apellidos</span>
              <span class="required">*</span>
            </div>
            <el-input
              v-model="form.model.fullName"
              :maxlength="128"
              placeholder="Juan Pérez García"
              size="large"
              @input="updateProgress"
            />
          </el-form-item>

          <el-form-item prop="phone">
            <div class="field-label">
              <i class="el-icon-phone"></i>
              <span>Tu número celular</span>
              <span class="required">*</span>
            </div>
            <el-input
              v-model.trim="form.model.phone"
              placeholder="3001234567"
              size="large"
              @input="updateProgress"
            />
          </el-form-item>

          <el-form-item prop="company.identificationTypeId">
            <div class="field-label">
              <i class="el-icon-document"></i>
              <span>Tipo documento de tu empresa</span>
              <span class="required">*</span>
            </div>
            <select-identification-type
                v-model.trim="form.model.company.identificationTypeId"
                name="identificationTypeId"
                @input="onValidateIdentificationPattern($event); updateProgress()"
                @set-identification-type-code="form.model.company.identificationTypeCode = $event"
                @set-identification-type-name="form.model.company.identificationTypeName = $event"
              ></select-identification-type>
          </el-form-item>

          <!-- <el-form-item prop="company.companyIdentification">
            <div class="field-label">
              <i class="el-icon-s-order"></i>
              <span>Ingresa el nit de tu empresa</span>
              <span class="required">*</span>
            </div>
            <el-input
              v-model.trim="form.model.company.companyIdentification"
              :maxlength="24"
              placeholder="900.123.456"
              size="large"
              @change="onChangeIdentification"
              @input="updateProgress"
            />
          </el-form-item> -->

          <!-- Reemplaza el el-form-item del NIT con este código -->
          <el-form-item prop="company.companyIdentification">
            <div class="field-label">
              <i class="el-icon-s-order"></i>
              <span>Ingresa el nit de tu empresa</span>
              <span class="required">*</span>
            </div>
            <el-input
              v-model.trim="form.model.company.companyIdentification"
              :maxlength="24"
              placeholder="900123456"
              size="large"
              @change="onChangeIdentification(); updateProgress()"
              @input="onChangeIdentification(); updateProgress()"
            >
              <template slot="append">
                <div class="dv-display">
                  <span class="dv-label">DV</span>
                  <span class="dv-value">{{ form.model.company.companyIdentificationCheck || '-' }}</span>
                </div>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="company.companyName">
            <div class="field-label">
              <i class="el-icon-office-building"></i>
              <span>Razón social de tu empresa</span>
              <span class="required">*</span>
            </div>
            <el-input
              v-model="form.model.company.companyName"
              :maxlength="128"
              placeholder="Mi Empresa Exitosa S.A.S."
              size="large"
              @input="updateProgress"
            />
            <div class="field-helper">
              Tal como aparece en Cámara de Comercio
            </div>
          </el-form-item>

          <!-- Security badges -->
          <div class="security-badges">
            <div class="badge">
              <i class="el-icon-lock"></i>
              <span>SSL Secure, pago seguro garantizado</span>
            </div>
            <div class="badge">
              <i class="el-icon-medal"></i>
              <span>Certificado ISO</span>
            </div>
            <div class="badge">
              <i class="el-icon-time"></i>
              <span>Sin permanencia</span>
            </div>
          </div>
        </el-form>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div class="pricing-container">
          <!-- Skeleton Loader for Pricing -->
          <div v-if="isLoading" class="pricing-card skeleton-pricing">
            <div class="plan-header">
              <div class="plan-info">
                <el-skeleton-item variant="text" style="width: 60%; height: 42px;" />
              </div>
              <div class="plan-badge">
                <el-skeleton-item variant="rect" style="width: 100%; height: 24px;" />
              </div>
            </div>

            <div class="pricing-display">
              <div class="original-price">
                <el-skeleton-item variant="text" style="width: 80%; height: 32px;" />
                <el-skeleton-item variant="text" style="width: 60%; height: 32px;" />
              </div>
              <div class="final-price">
                <el-skeleton-item variant="text" style="width: 80%; height: 32px; margin-bottom: 8px;" />
                <el-skeleton-item variant="text" style="width: 60%; height: 16px;" />
              </div>
            </div>

            <div class="savings-section">
              <el-skeleton-item variant="text" style="width: 90%; height: 18px; margin-bottom: 8px;" />
              <el-skeleton-item variant="text" style="width: 100%; height: 14px; margin-bottom: 4px;" />
              <el-skeleton-item variant="text" style="width: 80%; height: 14px;" />
            </div>

            <div class="cta-section">
              <el-skeleton-item variant="text" style="width: 100%; height: 12px; margin-bottom: 4px;" />
              <el-skeleton-item variant="text" style="width: 70%; height: 12px; margin-bottom: 16px;" />
              <el-skeleton-item variant="rect" style="width: 100%; height: 48px;" />
            </div>
          </div>

          <!-- Pricing Card -->
          <div v-else class="pricing-card">
            <div class="plan-header">
              <div class="plan-info">
                <h3 class="plan-title">
                  Plan {{ plan.planName }}
                </h3>
                <p v-if="couponData.id > 0" class="plan-subtitle">
                {{ frequencyText }}
                </p>
              </div>
              <div class="plan-badge">
                <span class="badge-text">Tu mejor aliado</span>
              </div>
            </div>

            <!-- Pricing display -->
            <div class="pricing-display">
              <div v-if="couponData.id > 0" class="original-price">
                <span class="price-amount">{{ originalPrice | formatToCurrency }}</span>
                <span class="discount-badge">{{ couponData.code }} -{{ couponData.discount || 30 }}%</span>
              </div>
              <div class="final-price">
                <div class="price-container">
                  <span class="amount">{{ finalPrice | formatToCurrency }}</span>
                </div>
                <div v-if="couponData.id > 0" class="period">
                  {{ couponData.name }}
                </div>
                <div v-else>
                  {{ frequencyText }}
                </div>
              </div>
            </div>

            <!-- Savings highlight -->
            <div v-if="couponData.id > 0" class="savings-section">
              <div class="savings-text">
                <span class="savings-title">¡Ahorra {{ amountSaved | formatToCurrency }} HOY! 🫨 </span>
                <span class="savings-subtitle">Únete a más de 🔝30.000+ empresas colombianas que ya confían en Aliaddo para facturar, administrar y crecer.</span>
              </div>
            </div>

            <!-- CTA Button -->
            <div class="cta-section">
              <div class="terms-text">
                🔐 Tus datos están protegidos. Al registrarte, aceptas nuestros
                <a href="https://assets.aliaddo.cloud/contrato-de-prestacion-de-servicios-aliaddo-v28-01-2022.docx.pdf" target="_blank">Términos</a> y
                <a href="https://aliaddo.com/privacidad/" target="_blank">Política de Datos</a>
              </div>

              <el-tooltip
                :content="isFormValid ? '🚀 Crear mi cuenta y comenzar con Aliaddo' : '🚀 Crear mi cuenta y comenzar con Aliaddo'"
                placement="top"
                :disabled="false"
              >
                <el-button
                  type="primary"
                  size="large"
                  class="cta-button"
                  :class="{ 'cta-disabled': !isFormValid }"
                  :disabled="!isFormValid"
                  :loading="loading"
                  @click="onRegister"
                >
                  <span v-if="isFormValid">
                    <i class="el-icon-right"></i>
                    🚀 Crear mi cuenta y comenzar con Aliaddo
                  </span>
                  <span v-else>🚀 Crear mi cuenta y comenzar con Aliaddo</span>
                </el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import { excelRound, roundUpToHundred } from '../../helpers/round'
import calculateIdentificationCheck from '@/helpers/identification-check'
import { fieldRequiredByBlur } from '@/helpers/validations'

export default {
  name: 'SignupFormWithPricing',
  props: {
    plan: {
      type: Object,
      default: () => ({ planName: 'Plan M-120' }),
    },
    originalPrice: {
      type: Number,
      default: 179900,
    },
    addOnsMandatory: {
      type: Array,
      default: () => [],
    },
    recurrence: {
      type: String,
      default: 'Yearly',
    },
    couponData: {
      type: Object,
      default: () => ({
        id: 0,
        productId: 0,
        code: null,
        name: null,
        status: 'Enabled',
        recurrence: 'Yearly',
        discount: 0,
        discountType: 'Percent',
        redemptionType: 'OneTime',
        redemptionLimit: null,
        validUpTo: null,
        maximumRedemption: null,
        redemptionQuantity: null,
        plans: [],
        addOns: [],
        createdAt: '0001-01-01T00:00:00',
        updatedAt: '0001-01-01T00:00:00',
      }),
    },
    company: {
      type: Object,
      default: () => ({}),
    },
    companyIdentificationCheck: {
      type: [String, Number],
      default: '',
    },
    service: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        model: {
          company: {
            companyIdentification: '',
            companyIdentificationCheck: '',
            companyName: '',
            identificationTypeId: '31',
            identificationTypeCode: 'NIT',
            identificationTypeName: 'NIT',
            companyStudentCardExpiration: '',
            companyStudentInstitutionCode: '',
            companyStudentInstitutionName: '',
          },
          email: '',
          firstName: '',
          fullName: '',
          ipAddress: '',
          lastName: '',
          phone: '',
          seller: '',
          source: '',
          userName: '',
          studentCard: '',
          addOns: [],
        },
        rules: {
          email: [
            { required: true, message: 'Email es requerido', trigger: 'blur' },
            { type: 'email', message: 'Formato de email inválido', trigger: 'blur' },
          ],
          fullName: [{ required: true, message: 'Nombre es requerido', trigger: 'blur' }],
          phone: [{ required: true, message: 'Teléfono es requerido', trigger: 'blur' }],
          'company.identificationTypeId': [{ required: true, message: 'Tipo de documento es requerido', trigger: 'change' }],
          'company.companyIdentification': [{ required: true, message: 'Número de identificación es requerido', trigger: 'blur' }],
          'company.companyName': [{ required: true, message: 'Razón social es requerida', trigger: 'blur' }],
        },
      },
      identificationTypes: [
        { id: '13', label: 'CC - Cédula de Ciudadanía' },
        { id: '31', label: 'NIT - Número de Identificación Tributaria' },
      ],
      digitoVerificacion: '',
      totalSteps: 6,
      requiredFields: [
        'email',
        'fullName',
        'phone',
        'company.identificationTypeId',
        'company.companyIdentification',
        'company.companyName',
      ],
    }
  },

  computed: {
    progressPercentage() {
      return Math.round((this.filledFields / this.totalSteps) * 100)
    },

    frequencyText() {
      const frequencies = {
        Monthly: 'Facturación mensual',
        Yearly: 'Facturación anual',
        Quarterly: 'Facturación trimestral',
        Semiannual: 'Facturación semestral',
      }

      return frequencies[this.recurrence] || 'Facturación anual'
    },

    frequencyShort() {
      const frequencies = {
        Monthly: 'mes',
        Yearly: 'año',
        Quarterly: 'trimestre',
        Semiannual: 'semestre',
      }

      return frequencies[this.recurrence] || 'año'
    },

    discountAmount() {
      if (!this.couponData.status === 'Enabled') return 0

      if (this.couponData.discountType === 'Percent' && +this.couponData.discount > 0) {
        return this.originalPrice * (this.couponData.discount / 100)
      }
      if (+this.couponData.discount > 0) {
        return this.originalPrice - this.couponData.discount
      }

      return 0
    },

    finalPrice() {
      return excelRound(this.originalPrice - this.discountAmount, -2)
    },

    amountSaved() {
      return roundUpToHundred(this.originalPrice - this.finalPrice)
    },

    filledFields() {
      return this.requiredFields.filter(field => this.isFieldValid(field)).length
    },

    remainingFields() {
      return this.totalSteps - this.filledFields
    },

    isFormValid() {
      return this.filledFields === this.totalSteps
    },
  },
  watch: {
    companyIdentificationCheck(newValue) {
      this.form.model.company.companyIdentificationCheck = newValue
    },
  },

  methods: {
    // Verificar si un campo está válido
    isFieldValid(fieldPath) {
      const value = this.getNestedValue(this.form.model, fieldPath)

      if (!value || (typeof value === 'string' && value.trim() === '')) {
        return false
      }

      // Validaciones específicas
      if (fieldPath === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        return emailRegex.test(value)
      }

      if (fieldPath === 'phone') {
        return value.length >= 10
      }

      if (fieldPath === 'company.companyIdentification') {
        // Verificar longitud mínima
        if (value.length < 4) {
          return false
        }

        // Verificar patrón regex si existe una regla definida
        const rules = this.form.rules['company.companyIdentification']
        if (rules && Array.isArray(rules)) {
          // Buscar la regla que tiene patrón
          const patternRule = rules.find(rule => rule.pattern)
          if (patternRule && patternRule.pattern) {
            return patternRule.pattern.test(value)
          }
        }

        // Si no hay patrón definido, solo validar longitud
        return true
      }

      return true
    },

    validateIdentificationPattern(value) {
      const _this = this
      _this.form.rules['company.companyIdentification'] = []
      if (+value === 41 || +value === 42 || +value === 50) {
        _this.form.rules['company.companyIdentification'].push(fieldRequiredByBlur, {
          message: _this.$tc('fieldHasInvalidCharacter'),
          pattern: /^[a-zA-Z0-9_\-]{4,16}$/,
          required: true,
          trigger: 'blur',
        })
      } else if (+value === 13) {
        _this.form.rules['company.companyIdentification'].push(fieldRequiredByBlur, {
          message: _this.$tc('fieldHasInvalidCharacter'),
          pattern: /^[1-9][0-9]{3,9}$/,
          required: true,
          trigger: 'blur',
        })
      } else if (+value === 21) {
        _this.form.rules['company.companyIdentification'].push(fieldRequiredByBlur, {
          message: _this.$tc('fieldHasInvalidCharacter'),
          pattern: /^([a-zA-Z]{1,5})?[1-9][0-9]{3,7}$/,
          required: true,
          trigger: 'blur',
        })
      } else if (+value === 12) {
        _this.form.rules['company.companyIdentification'].push(fieldRequiredByBlur, {
          message: _this.$tc('fieldHasInvalidCharacter'),
          pattern: /^[1-9][0-9]{4,11}$/,
          required: true,
          trigger: 'blur',
        })
      } else if (+value === 31) {
        _this.form.rules['company.companyIdentification'].push(fieldRequiredByBlur, {
          message: _this.$tc('fieldHasInvalidCharacter'),
          pattern: /^[1-9]\d{6,9}$/,
          required: true,
          trigger: 'blur',
        })
      } else {
        _this.form.rules['company.companyIdentification'].push(fieldRequiredByBlur)
      }
    },

    // Obtener valor anidado del objeto
    getNestedValue(obj, path) {
      return path.split('.').reduce((current, key) => (current && current[key] !== undefined ? current[key] : null), obj)
    },

    // Actualizar progreso
    updateProgress() {
      this.$forceUpdate()
    },

    onChangeEmail(value) {
      this.$emit('email-changed', value)
    },

    onChangeIdentification() {
      this.$emit('identification-changed', this.form.model.company.companyIdentification)
      this.validateIdentificationPattern(this.form.model.company.identificationTypeId || '13')
    },

    onValidateIdentificationPattern() {
      this.$emit('identification-type-changed', this.form.model.company.identificationTypeId)
      this.validateIdentificationPattern(this.form.model.company.identificationTypeId)
    },

    async onRegister() {
      if (!this.isFormValid) {
        this.$message.warning('Por favor completa todos los campos requeridos')

        return
      }

      this.loading = true

      try {
        const isValid = await new Promise(resolve => {
          this.$refs.formUser.validate(valid => {
            resolve(valid)
          })
        })
        if (isValid) {
          this.$emit('register', this.form.model)
        } else {
          this.$message.error('Por favor corrige los errores en el formulario')
        }
      } catch (error) {
        console.error('Error en validación:', error)
        this.$message.error('Error al validar el formulario')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// Variables de color de marca Aliaddo
$aliaddo-primary: #6B46C1;
$aliaddo-primary-light: #8B5CF6;
$aliaddo-primary-dark: #553C9A;
$aliaddo-secondary: #EC4899;
$aliaddo-accent: #10B981;
$aliaddo-warning: #F59E0B;
$aliaddo-danger: #EF4444;

.savings-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.field-label {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
  font-weight: 500;
  color: #374151;
  font-size: 14px;

  i {
    margin-right: 8px;
    color: $aliaddo-primary;
    font-size: 16px;
  }
}

.required {
  color: $aliaddo-danger;
  margin-left: 4px;
}

.signup-layout {
  background: #f8fafc;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-x: hidden;
}

.form-container {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 1200px;
}

.logo-section {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f3f4f6;

  .header-logo {
    max-height: 45px;
    width: auto;
  }
}

.progress-section {
  margin-bottom: 24px;

  .progress-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    .progress-title {
      font-size: 14px;
      font-weight: 500;
      color: #374151;
    }

    .progress-count {
      font-size: 14px;
      color: #6b7280;
      font-weight: 500;
    }
  }

  .progress-bar-container {
    .progress-bar {
      width: 100%;
      height: 6px;
      background: #e5e7eb;
      border-radius: 3px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background: linear-gradient(90deg, $aliaddo-primary, $aliaddo-primary-light);
        border-radius: 3px;
        transition: width 0.3s ease;
      }
    }
  }
}

// Reducir espaciado entre campos del formulario
::v-deep .el-form-item {
  margin-bottom: 12px;
}

::v-deep .el-form-item__label {
  color: #374151;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 2px;
  padding: 0;
}

::v-deep .el-input__inner {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  height: 48px;

  &:focus {
    border-color: $aliaddo-primary;
    box-shadow: 0 0 0 3px rgba(107, 70, 193, 0.1);
  }
}

::v-deep .el-select .el-input__inner {
  cursor: pointer;
}

.field-helper {
  margin-top: 2px;
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
}

.security-badges {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
  text-align: center;

  .badge {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;

    &:nth-child(1) {
      // SSL Seguro - Verde
      color: $aliaddo-accent;

      i.el-icon-lock {
        color: $aliaddo-accent;
      }
    }

    &:nth-child(2) {
      // Certificado ISO - Azul
      color: #409EFF;

      i.el-icon-medal {
        color: #409EFF;
      }
    }

    &:nth-child(3) {
      // Sin permanencia - Morado
      color: $aliaddo-primary-light;

      i.el-icon-time {
        color: $aliaddo-primary-light;
      }
    }
  }
}

.pricing-container {
  position: sticky;
  top: 40px;
}

.pricing-card {
  background: white;
  overflow: hidden;
}

.plan-header {
  padding: 24px 24px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;

  .plan-info {
    text-align: left;
    flex: 1;
  }

  .plan-badge {
    background: $aliaddo-primary-dark;
    color: white;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
    flex-shrink: 0;
  }

  .plan-title {
    margin: 0 0 4px 0;
    font-size: 24px;
    font-weight: 700;
    color: #111827;
    line-height: 1.2;
  }

  .plan-subtitle {
    margin: 0;
    color: #6b7280;
    font-size: 14px;
    line-height: 1.3;
  }
}

.pricing-display {
  padding: 0 24px 24px;
  text-align: center;

  .coupon-applied {
    background: linear-gradient(135deg, #F3E8FF 0%, #E0E7FF 100%);
    border: 1px solid rgba(107, 70, 193, 0.2);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    text-align: center;

    .coupon-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin-bottom: 8px;

      i {
        color: $aliaddo-primary;
        font-size: 18px;
      }

      .coupon-code {
        font-weight: 700;
        font-size: 16px;
        color: $aliaddo-primary-dark;
        background: white;
        padding: 4px 12px;
        border-radius: 6px;
        border: 1px solid rgba(107, 70, 193, 0.3);
        letter-spacing: 0.5px;
      }

      .coupon-label {
        font-size: 14px;
        color: $aliaddo-primary;
        font-weight: 600;
      }
    }

    .coupon-description {
      font-size: 13px;
      color: $aliaddo-primary;
      font-weight: 500;
      opacity: 0.9;
      line-height: 1.3;
    }
  }

  .original-price {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 8px;

    .price-amount {
      font-size: 18px;
      color: #9ca3af;
      text-decoration: line-through;
    }

    .discount-badge {
      background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
      color: white;
      padding: 2px 6px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  .final-price {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;

    .price-container {
      display: flex;
      align-items: baseline;
      justify-content: center;
      gap: 2px;
      margin-bottom: 4px;

      .currency {
        font-size: 28px;
        font-weight: 700;
        color: #111827;
      }

      .amount {
        font-size: 48px;
        font-weight: 900;
        color: #111827;
        line-height: 1;
      }
    }

    .period {
      font-size: 14px;
      color: #6b7280;
      text-align: center;
    }
  }
}

.savings-section {
  background: linear-gradient(135deg, #F3E8FF 0%, #E0E7FF 100%);
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  text-align: center;
  border: 1px solid rgba(107, 70, 193, 0.1);

  .savings-text {
    .savings-title {
      font-size: 18px;
      font-weight: 600;
      color: $aliaddo-primary-dark;
      margin: 0 0 8px 0;
      display: block;
    }

    .savings-subtitle {
      font-size: 14px;
      color: $aliaddo-primary;
      margin: 0;
      font-weight: 500;
    }
  }
}

.cta-section {
  padding: 24px;

  .cta-button {
    width: 100%;
    height: 56px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
    border: none;
    color: white;
    border-radius: 8px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 14px rgba(79, 70, 229, 0.4);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #4338CA 0%, #6D28D9 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(79, 70, 229, 0.5);
    }

    &.cta-disabled {
      background: #e5e7eb;
      color: #9ca3af;
      cursor: not-allowed;
      box-shadow: none;

      &:hover {
        background: #e5e7eb;
        transform: none;
      }
    }

    i {
      margin-right: 8px;
    }
  }

  .terms-text {
    text-align: center;
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 16px;
    line-height: 1.5;

    a {
      color: $aliaddo-primary;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// Responsive
@media (max-width: 992px) {
  .signup-layout {
    padding: 20px 10px;
  }

  .form-container {
    padding: 24px;
    margin-bottom: 20px;
  }

  .pricing-container {
    position: static;
  }
}

@media (max-width: 768px) {
  .signup-layout {
    padding: 20px 5px;
  }

  .form-container {
    padding: 20px;
  }

  .security-badges {
    flex-direction: column;
    gap: 8px;
    align-items: center;

    .badge {
      justify-content: center;
    }
  }

  .final-price .amount {
    font-size: 36px;
  }

  .el-row {
    flex-direction: column;
  }

  .pricing-container {
    margin-bottom: 24px;
  }
}

@media (max-width: 576px) {
  .signup-layout {
    padding: 10px;
  }

  .form-container {
    padding: 16px;
  }

  .pricing-card {
    margin-bottom: 20px;
  }

  .cta-button {
    font-size: 14px;
    height: 48px;
    padding: 0 12px;
  }

  .security-badges {
    justify-content: center;
    text-align: center;
    align-items: center;

    .badge {
      justify-content: center;
      text-align: center;
    }
  }
}

// Skeleton Loader Styles
.skeleton-form {
  .skeleton-field {
    margin-bottom: 20px;
  }

  .skeleton-badges {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #f3f4f6;
  }
}

.skeleton-pricing {
  .plan-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;

    .plan-info {
      flex: 1;
    }

    .plan-badge {
      margin-left: 16px;
      min-width: 120px;
    }
  }

  .pricing-display {
    margin-bottom: 24px;

    .original-price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .final-price {
      text-align: center;
      margin-bottom: 16px;
    }
  }

  .savings-section {
    background: linear-gradient(135deg, #F3E8FF 0%, #E0E7FF 100%);
    padding: 24px;
    border-radius: 8px;
    margin-bottom: 24px;
    border: 1px solid rgba(107, 70, 193, 0.1);
  }

  .cta-section {
    padding: 24px;
  }
}

// Skeleton animation
::v-deep .el-skeleton__item {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

// Estilos mejorados para el dígito de verificación
.dv-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-left: 2px solid #e2e8f0;
  min-width: 50px;
  height: 100%;

  .dv-label {
    font-size: 10px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1;
    margin-bottom: 2px;
  }

  .dv-value {
    font-size: 16px;
    font-weight: 800;
    color: #1e293b;
    line-height: 1;
    font-family: 'SF Mono', 'Monaco', 'Menlo', monospace;

    &:empty::before {
      content: '-';
      color: #94a3b8;
    }
  }
}

// Estilos para el append de Element UI
::v-deep .el-input-group__append {
  background: transparent;
  border: 1px solid #d1d5db;
  border-left: none;
  padding: 0;
  border-radius: 0 6px 6px 0;

  &:hover {
    .dv-display {
      background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);

      .dv-value {
        color: #6B46C1;
      }
    }
  }
}

// Asegurar que el input principal tenga el borde correcto
::v-deep .el-input-group .el-input__inner {
  border-radius: 6px 0 0 6px;
  border-right: none;

  &:focus {
    border-color: #6B46C1;
    box-shadow: 0 0 0 3px rgba(107, 70, 193, 0.1);

    + .el-input-group__append {
      border-color: #6B46C1;

      .dv-display {
        background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
        border-left-color: #6B46C1;

        .dv-value {
          color: #6B46C1;
        }

        .dv-label {
          color: #6B46C1;
        }
      }
    }
  }
}

// Responsive
@media (max-width: 768px) {
  .dv-display {
    padding: 6px 12px;
    min-width: 45px;

    .dv-label {
      font-size: 9px;
    }

    .dv-value {
      font-size: 14px;
    }
  }
}
</style>
